import { render, staticRenderFns } from "./signonglass-orders.vue?vue&type=template&id=1e639e62&scoped=true"
import script from "./signonglass-orders.vue?vue&type=script&lang=js"
export * from "./signonglass-orders.vue?vue&type=script&lang=js"
import style0 from "./signonglass-orders.vue?vue&type=style&index=0&id=1e639e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e639e62",
  null
  
)

export default component.exports